import { render, staticRenderFns } from "./ActualizarRF.vue?vue&type=template&id=bb46433a"
import script from "./ActualizarRF.vue?vue&type=script&lang=js"
export * from "./ActualizarRF.vue?vue&type=script&lang=js"
import style0 from "./ActualizarRF.vue?vue&type=style&index=0&id=bb46433a&prod&scooped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports